import React from 'react';
import { getAPIData, getAPIDataParams } from '../../../utils/apiFunction';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";

const getAccountOptionLabel = (option) => String(option?.description ?? option?.name ?? '').trim();
const getAccountOptionSearchText = (option) => {
    const description = getAccountOptionLabel(option);
    const myobId = String(option?.myobid ?? option?.MYOBID ?? option?.myobId ?? '').trim();

    return [description, myobId].filter(Boolean).join(' ').toLowerCase();
};
const filterAccountOptions = (options, state) => {
    const searchValue = String(state?.inputValue ?? '').trim().toLowerCase();

    if (!searchValue) {
        return options;
    }

    return options.filter((option) => getAccountOptionSearchText(option).includes(searchValue));
};

const AccountSelect = (props) => {
    const [account, setAccount] = React.useState([]);
    const [value, setValue] = React.useState(props.state);
    const [inputValue, setInputValue] = React.useState('');

    const filterVals = (list) => {
        setAccount(list.sort((a, b) => {
            return a.description > b.description ? 1 : -1;
        }))
    }
    React.useEffect(() => {

        if (props.accountId) {
            var est = account.find((dr) => { return (dr.id === props.accountId) });
            props.setState(est);
            setValue(est);
        }
    }, [account, props.accountId])

    React.useEffect(() => {
        getAPIData('/APBills/GetAccounts', filterVals);
    }, [])

    return (<Autocomplete
        value={value}
        disabled={props.disabled}
        onChange={(event, newValue) => {
            props.setState(newValue);
            setValue(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
        }}
        filterOptions={filterAccountOptions}
        getOptionLabel={getAccountOptionLabel}
        disablePortal
        id="accountbox"
        options={account}
        sx={props.widthAuto?{width:'auto'}:{ width: 300 }}
        renderInput={(params) => <TextField {...params} label="Account" />}
    />);
}
export default AccountSelect;